import { useQuery } from "@tanstack/react-query";
import { Moment } from "config";
import { API } from "config";

const useProductOrderDetail = (productName, { type, status, client, distributorId, orderBy, period } = {}) =>
    useQuery({
        queryKey: ["product-order-detail", productName, type, status, client, distributorId, orderBy, period],
        enabled: !!productName && !!period,
        queryFn: async () => {
            if (!productName || !period || period.length !== 2) return null;

            const startFormatted = Moment(period[0]).format("YYYY-MM-DD");
            const endFormatted = Moment(period[1]).format("YYYY-MM-DD");

            const url =
                `/reports/products/detail?product_name=${encodeURIComponent(productName)}` +
                `&period[]=${startFormatted}` +
                `&period[]=${endFormatted}` +
                (type ? `&type=${type}` : "") +
                (status ? `&status=${status}` : "") +
                (client ? `&client=${client}` : "") +
                (distributorId ? `&distributor_id=${distributorId}` : "") +
                (orderBy ? `&order_by=${orderBy}` : "");

            const callback = await API.get(url);
            return callback?.data;
        },
    });

export default useProductOrderDetail;
